/**
 * Sailboat Model Picker - Enhanced select with Choices.js and JSON data
 */

document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for all scripts to load
  setTimeout(initSailboatPicker, 200);
});

function initSailboatPicker() {
  const selects = document.querySelectorAll('[data-sailboat-model-select]:not([data-choices-initialized]):not([data-error-state])');
  
  if (selects.length === 0) {
    return;
  }

  // Check if Choices.js is available
  if (typeof Choices === 'undefined') {
    console.warn('Choices.js not available, falling back to regular select');
    return;
  }

  // Fetch the sailboat models JSON (prefer URL injected by Liquid)
  const jsonUrl = window.SAILBOAT_MODELS_URL || (
    window.Shopify?.routes?.root
      ? window.Shopify.routes.root + 'assets/sailboat-models.json'
      : '/assets/sailboat-models.json'
  );

  fetch(jsonUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(models => {
      if (!Array.isArray(models) || models.length === 0) {
        throw new Error('Invalid or empty sailboat models data');
      }
      selects.forEach(select => {
        populateAndEnhanceSelect(select, models);
      });
    })
    .catch(error => {
      console.warn('Failed to load sailboat models:', error);
      // Show disabled select with error message
      selects.forEach(select => {
        showErrorState(select);
      });
    });
}

/**
 * Populates a select element with sailboat models and enhances it with Choices.js
 * @param {HTMLSelectElement} select - The select element to populate
 * @param {Object[]} models - Array of sailboat model objects
 */
function populateAndEnhanceSelect(select, models) {
  // Store models data for later use
  window.sailboatModelsData = models;
  
  // Clear existing options except the first placeholder
  const placeholder = select.firstElementChild;
  select.innerHTML = '';
  
  // Re-add placeholder if it existed
  if (placeholder && placeholder.value === '') {
    select.appendChild(placeholder);
  } else {
    // Create default placeholder
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select model...';
    select.appendChild(defaultOption);
  }

  // Add model options
  models.forEach(model => {
    const option = document.createElement('option');
    option.value = model.title;  // Use title as value for sailboat_model property
    option.textContent = model.title;
    option.setAttribute('data-model-id', model.id);  // Store ID in data attribute for API calls
    select.appendChild(option);
  });

  // Initialize Choices.js
  initializeChoicesForSelect(select);
  
  // Set up change handler for customizer fields
  setupCustomizerHandler(select);
}

/**
 * Shows error state for a select element when data loading fails
 * @param {HTMLSelectElement} select - The select element to show error for
 */
function showErrorState(select) {
  // Clear existing options
  select.innerHTML = '';
  
  // Add error option
  const errorOption = document.createElement('option');
  errorOption.value = '';
  errorOption.textContent = 'Unable to load sailboat models';
  errorOption.disabled = true;
  errorOption.selected = true;
  select.appendChild(errorOption);
  
  // Disable the select
  select.disabled = true;
  select.setAttribute('data-error-state', 'true');
  
  // Add visual indicator
  select.style.opacity = '0.6';
  select.style.cursor = 'not-allowed';
}

/**
 * Initializes Choices.js for a select element
 * @param {HTMLSelectElement} select - The select element to enhance
 */
function initializeChoicesForSelect(select) {
  if (select.getAttribute('data-choices-initialized')) {
    return;
  }

  try {
    // Enhanced Choices.js configuration per updated plan
    const choices = new Choices(select, {
      searchEnabled: true,
      allowHTML: false,
      removeItemButton: true,
      addItems: true,
      duplicateItemsAllowed: false,
      searchResultLimit: 6,
      noResultsText: (value) => `No matches. <a href="/pages/contact" target="_blank" rel="noopener">Contact Us</a> to submit a custom request!`,
      searchPlaceholderValue: 'Type to search sailboats...',
      itemSelectText: '',
      shouldSort: false,
      fuseOptions: {
        threshold: .4, // lower = stricter
        ignoreLocation: true,
        minMatchCharLength: 2 
      }      
    });

    select.setAttribute('data-choices-initialized', 'true');
    select._choicesInstance = choices;
    
  } catch (error) {
    console.warn('Failed to initialize Choices.js:', error);
  }
}

/**
 * Sets up the change handler for showing/hiding and populating customizer fields
 * @param {HTMLSelectElement} select - The select element to monitor
 */
function setupCustomizerHandler(select) {
  // Find the customizer fields container
  const container = select.closest('.sailboat-picker');
  const customizerFields = container.querySelector('.sailboat-customizer-fields');
  const titleInput = container.querySelector('[data-sailboat-title-input]');
  const schematicIdInput = container.querySelector('[data-sailboat-schematic-id-input]');
  const helperText = container.querySelector('[data-sailboat-helper-text]');
  const announcementRegion = container.querySelector('[data-sailboat-announcement]');
  
  if (!customizerFields || !titleInput) {
    console.warn('Customizer fields not found');
    return;
  }
  
  // Initialize API client
  const api = new DrawscapeApi();
  
  // Handle select change
  select.addEventListener('change', async function(e) {
    const selectedTitle = e.target.value;
    
    if (!selectedTitle) {
      // Hide fields and show helper text if no selection
      customizerFields.style.display = 'none';
      if (helperText) helperText.style.display = 'block';
      titleInput.value = '';
      if (schematicIdInput) schematicIdInput.value = '';
      // Remove loading state
      container.classList.remove('is-loading');
      return;
    }
    
    // Get the UUID from the selected option
    const selectedOption = e.target.options[e.target.selectedIndex];
    const schematicId = selectedOption.getAttribute('data-model-id');
    
    if (!schematicId) {
      console.warn('No schematic ID found for selected option');
      return;
    }
    
    try {
      // Enter loading state
      container.classList.add('is-loading');
      if (helperText) helperText.style.display = 'none';
      
      // Disable add to cart button if it exists
      const addToCartButton = document.querySelector('[name="add"]');
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
      
      // Fetch schematic data from API
      console.log(`Fetching schematic data for ID: ${schematicId}`);
      const schematicData = await api.getSchematic(schematicId);
      
      // Show fields and populate with API data
      customizerFields.style.display = 'block';
      
      // Use display_title from API or fall back to selected title
      titleInput.value = schematicData.display_title || selectedTitle;
      // Set the schematic ID for internal use
      if (schematicIdInput) schematicIdInput.value = schematicId;
      
      // Announce to screen readers
      if (announcementRegion) {
        announcementRegion.textContent = 'Title field is now available for editing.';
      }
      
    } catch (error) {
      console.error('Failed to fetch schematic data:', error);
      
      // Show error message to user
      if (announcementRegion) {
        announcementRegion.textContent = 'Failed to load boat details. Please try again.';
      }
      
      // Still show the fields with default values
      customizerFields.style.display = 'block';
      titleInput.value = selectedTitle;
      if (schematicIdInput) schematicIdInput.value = schematicId;
      
    } finally {
      // Exit loading state
      container.classList.remove('is-loading');
      
      // Re-enable add to cart button
      const addToCartButton = document.querySelector('[name="add"]');
      if (addToCartButton) {
        addToCartButton.disabled = false;
      }
    }
  });
}